import React from "react"
import { Widget, fromJSX } from "widgets-for-react"
import { ComponentDidMount, ComponentWillUnmount } from "../../../../../utils/lifecycleMethods"

export const jotformEventsWidget = (): Widget<never> => 
  fromJSX((setState) => (
      <>
        <ComponentDidMount onMount={() => handleJotformMountEvents()}/>
        <ComponentWillUnmount onUnmount={() => handleJotformUnMountEvents()} />
      </>
    )
  )

function handleJotformMountEvents() {
  const anyWindow = window as any;

  anyWindow.handleIFrameMessage = function (e: MessageEvent) {
    if (typeof e.data === 'object') { return; }
    var args = e.data.split(":");
    let iframe: HTMLIFrameElement;

    if (args.length > 2) {
      iframe = document.getElementById("JotFormIFrame-" + args[(args.length - 1)]) as HTMLIFrameElement;
    } else {
      iframe = document.getElementById("JotFormIFrame") as HTMLIFrameElement;
    }

    if (!iframe) { return; }

    switch (args[0]) {
      case "scrollIntoView":
        iframe.scrollIntoView();
        break;

      case "setHeight":
        iframe.style.height = args[1] + "px";
        if (!isNaN(args[1]) && parseInt(iframe.style.minHeight) > parseInt(args[1])) {
          iframe.style.minHeight = args[1] + "px";
        }
        break;

      case "collapseErrorPage":
        if (iframe.clientHeight > anyWindow.innerHeight) { iframe.style.height = anyWindow.innerHeight + "px"; }
        break;

      case "reloadPage":
        anyWindow.location.reload();
        break;

      case "loadScript":
        if (!anyWindow.isPermitted(e.origin, ['jotform.com', 'jotform.pro'])) { break; }
        var src = args[1];
        if (args.length > 3) { src = args[1] + ':' + args[2]; }
        var script = document.createElement('script');
        script.src = src;
        script.type = 'text/javascript';
        document.body.appendChild(script);
        break;

      case "exitFullscreen":
        if (anyWindow.document.exitFullscreen) anyWindow.document.exitFullscreen();
        else if (anyWindow.document.mozCancelFullScreen) anyWindow.document.mozCancelFullScreen();
        else if (anyWindow.document.mozCancelFullscreen) anyWindow.document.mozCancelFullScreen();
        else if (anyWindow.document.webkitExitFullscreen) anyWindow.document.webkitExitFullscreen();
        else if (anyWindow.document.msExitFullscreen) anyWindow.document.msExitFullscreen();
        break;
    }

    var isJotForm = (e.origin.indexOf("jotform") > -1) ? true : false;
    if (iframe.contentWindow && isJotForm && "contentWindow" in iframe && "postMessage" in iframe.contentWindow) {
      var urls = { "docurl": encodeURIComponent(document.URL), "referrer": encodeURIComponent(document.referrer) };
      iframe.contentWindow.postMessage(JSON.stringify({ "type": "urls", "value": urls }), "*");
    }
  };

  anyWindow.isPermitted = function (originUrl: string, whitelisted_domains: Array<string>) {
    var url = document.createElement('a');
    url.href = originUrl;
    var hostname = url.hostname;
    var result = false;
    if (typeof hostname !== 'undefined') {
      whitelisted_domains.forEach(function (element) {
        if (hostname.slice((-1 * element.length - 1)) === '.'.concat(element) || hostname === element) { result = true; }
      });
      return result;
    }
  };

  if (anyWindow.addEventListener) { anyWindow.addEventListener("message", anyWindow.handleIFrameMessage, false); }
}

export function handleJotformUnMountEvents() {
  const anyWindow = window as any;

  if (anyWindow.removeEventListener) { 
    anyWindow.removeEventListener("message", anyWindow.handleIFrameMessage, false); 
  }
}
